import N from "../../node_modules/classnames/index.js";
import { forwardRef as g } from "react";
import h from "../../node_modules/lodash/groupBy.js";
import B from "../../node_modules/lodash/sortBy.js";
import j from "../../node_modules/lodash/toNumber.js";
import { Button as I } from "../Blocks/Button/Button.js";
import "./UIInputButtonGroup2.js";
import { jsx as e, jsxs as R } from "../../_virtual/jsx-runtime.js";
function $({
  hasError: i,
  options: n,
  className: m,
  disabled: c,
  onBlur: l,
  variant: p = "outline",
  size: d = "medium",
  onChange: o,
  value: s
}, f) {
  const a = h(n, (r) => r.row || 1), b = Math.min(...Object.keys(a).map(j)), _ = (r, u) => {
    if ((r.row || 1) === b && u === 0)
      return f;
  };
  return /* @__PURE__ */ e("div", {
    className: N("input-button-group shakeable", m),
    "data-error": i,
    children: B(Object.entries(a), ([r]) => r).map(([r, u]) => /* @__PURE__ */ e("div", {
      className: "input-button-group__row",
      children: u.map((t, v) => /* @__PURE__ */ R("div", {
        className: "input-button-group__button-container",
        children: [/* @__PURE__ */ e(I, {
          disabled: c,
          ref: _(t, v),
          className: "input-button-group__button",
          size: d,
          variant: p,
          selected: s === t.value,
          onBlur: l,
          onClick: () => o && s !== t.value && o({
            target: {
              value: t.value
            }
          }),
          children: t.label
        }, `${t.value}${t.row}`), t.description && /* @__PURE__ */ e("p", {
          className: "input-button-group__description",
          children: t.description
        })]
      }, `${t.label}${t.value}`))
    }, r))
  });
}
const q = g($);
export {
  q as UIInputButtonGroup
};
//# sourceMappingURL=UIInputButtonGroup.js.map
